<div class="dialog" *ngIf="visible">
    <div class="container m-b-4">
        <div class="row">
            <div class="col">
                <h1>{{ applicationInfo.propName }}</h1>
            </div>
            <div class="col-md-auto">
                <p><b>Status: {{ applicationInfo.status }}</b></p>
            </div>

        </div>

        <div class="row">
            <div class="col-md-4">
                <div class="valuation-heading">
                    <span class="inner-heading">Application Details</span>
                </div>
                <p>Property Name: {{ applicationInfo.propName }}</p>
                <p>Property Contact: {{ applicationInfo.contact }}</p>
                <p>Property Email: {{ applicationInfo.email }}</p>
                <p>Property Document: {{ applicationInfo.document_url }}</p>
                <p>Application Status: {{ applicationInfo. status }}</p>
            </div>

            <div class="col">
                <div class="valuation-heading">
                    <div class="row">
                        <div class="col">
                            <span class="inner-heading">Description</span>
                        </div>
                        <!-- <div class="col-md-auto">
                            <div class="row">
                                <div class="col-md-6">
                                    <input class="btn btn-primary" type="button" value="Approve">
                                </div>

                                <div class="col-md-6">
                                    <input class="btn btn-danger" type="button" value="Reject">
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
                <p>Property Description</p>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="valuation-heading">
                    <span class="inner-heading">Uploaded Proposal</span>
                </div>
            </div>

            <div class="col-md-12">
                <div class="alert alert-success" role="alert">
                    <div class="row">
                        <div class="col">
                            <i class="fa fa-file" aria-hidden="true"></i> &nbsp; &nbsp; <a class="link"
                                id="proposalLink">{{
                                applicationInfo.document_url }}</a>
                        </div>
                        <div class="col-md-auto text-center">
                            <a class="link" (click)="onViewProposal()">View</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row d-flex justify-content-center" *ngIf="isLoading">
            <img class="loader" src="../../../../assets/images/loader.gif" width="60px" alt="">
        </div>

        <div class="alert alert-success" *ngIf="application_approved" role="alert" style="margin: 10px;">
            Application Approved
        </div>

        <div class="alert alert-primary" *ngIf="application_rejected" role="alert" style="margin: 10px;">
            Application Rejected
        </div>

        <fieldset *ngIf="showButtons">
            <input type="button" class="ApproveBtn" value="Approve" (click)="onApprovedApplication(applicationInfo)" />
            <input type="button" class="RejectBtn" value="Reject" (click)="onShowTextarea()" />
        </fieldset>

        
        <div class="row" *ngIf="showTextarea">
            <form [formGroup]="rejectForm" style="width: 100%;">
                <div class="col-md-12 form-group">
                    <textarea formControlName="description" class="form-control" id="reject_cause" placeholder="Specify reason for rejection"></textarea>
                </div>
    
                <input type="button" class="SubmitBtn" value="Submit" (click)="onRejectApplication(applicationInfo)" />
            </form>
        </div>

    </div>
</div>